import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Table, Tooltip } from 'components';
import { GeneralService, MembershipService } from 'services';
import { Globals, Constants } from 'utils';
import { AddImage } from 'assets/img';
import { TrashIcon, CheckWhiteIcon } from 'assets/icons';
import { MembershipServiceItem, MembershipImage } from 'types';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
  colors?: any;
}

const SERVICE_NOT_IN_LIST = [[]];

class CreateMembership extends React.Component<Props> {
  state = {
    form: {
      name: '',
      price_month: '',
      price_year: '',
      month: Constants.PRICE_STATUS.NO,
      year: Constants.PRICE_STATUS.NO,
      area_id: '',
      image: '' as string | MembershipImage,
      level_id: '',
      color_id: '',
      service_id: '',
      specialized: false,
      signs: null,
      is_free: false,
    },
    colors: this.props.colors || [],
    services: [] as MembershipServiceItem[],
    areas: [] as any[],
  };

  componentDidMount() {
    this.load();
    this.getSelects();
  }

  load = async () => {
    const res: any = await MembershipService.admin.getServices({
      membership_id: this.props.item?.id,
    });
    let signsActive = false;
    this.setState(
      {
        services:
          res.services.map((i: any) => {
            i.active = false;
            i.uses = 0;
            i.unlimited = false;

            const item = res.membership?.membership_services.find(
              (item: any) => item.service_id == i.id,
            );

            if (item) {
              i.active = true;
              i.uses = item.uses || 0;
              i.unlimited = item.unlimited == 1;
              i.marketplace = item.marketplace;
            }

            if (item && item.service_id == Constants.SERVICES.SIGN) {
              i.active = true;
              i.uses = 0;
              i.unlimited = true;
              signsActive = true;
            }
            return i;
          }) || [],
      },
      () => {
        if (this.props.item) {
          this.setState({
            form: {
              ...this.state.form,
              level_id: this.props.item?.level_id || '',
              name: this.props.item?.name || '',
              year: this.props.item?.year || Constants.PRICE_STATUS.NO,
              month: this.props.item?.month || Constants.PRICE_STATUS.NO,
              price_month: this.props.item?.price_month || '',
              price_year: this.props.item?.price_year || '',
              color_id: this.props.item?.color_id || '',
              specialized: this.props.item?.specialized || false,
              area_id: !!this.props.item?.areas?.length ? this.props.item?.areas[0]?.area_id : '',
              marketplace: this.props.item?.marketplace || false,
              signs: signsActive,
              is_free: this.props.item?.is_free || false,
            },
          });
        }
      },
    );
  };

  getSelects = async () => {
    const selects: any = await GeneralService.getSelects({
      area: true,
    });

    this.setState({
      areas: selects.areas || [],
    });
  };

  getServices = (active = false) => {
    const { services, form } = this.state;

    if (form.specialized) {
      const _services = services.filter(
        (i: any) =>
          i.active === active &&
          (i.id === Constants.SERVICES.CHAT ||
            i.id === Constants.SERVICES.CALL ||
            i.id === Constants.SERVICES.PREPARATION ||
            i.id === Constants.SERVICES.BOTPRESS_CHAT ||
            i.id === Constants.SERVICES.FORMALITIES),
      );
      return _services;
    }

    const _services = services.filter(
      (i: any) =>
        i.active === active &&
        (i.id === Constants.SERVICES.CHAT ||
          i.id === Constants.SERVICES.CALL ||
          i.id === Constants.SERVICES.BOTPRESS_CHAT ||
          i.id === Constants.SERVICES.REVISION ||
          i.id === Constants.SERVICES.PREPARATION ||
          i.id === Constants.SERVICES.FORMALITIES ||
          i.id === Constants.SERVICES.LAWYER_DIRECTORY ||
          i.id === Constants.SERVICES.COWORKING),
    );
    return _services;
  };

  submit = async (e: any) => {
    e.preventDefault();

    const services = this.state.services.filter(
      (i: any) => i.active && !i.unlimited && !i.uses && !i.without_quantity,
    );
    const preparationService = this.state.services.find(
      (i: any) => i.id === Constants.SERVICES.PREPARATION && i.active,
    );

    const validUses = services.every((i: any) => Globals.isValidIntegerString(i.uses));

    const serviceToAdd = this.state.services.filter((i: any) => i.active || i.marketplace);

    if (services.length > 0) {
      Globals.showError('Debe ingresar los usos de cada servicio asignado');
      return;
    }

    if (!validUses) {
      Globals.showError('Los usos deben ser números');
      return;
    }

    if (preparationService && parseInt(preparationService.uses as any) > 5) {
      Globals.showError('El servicio de elaboración de documentos no puede tener más de 5 usos');
      return;
    }

    if (this.state.form.specialized && !this.state.form.area_id) {
      Globals.showError('Debe seleccionar una área');
      return;
    }

    if (!this.state.form.is_free) {
      if (!this.state.form.month && !this.state.form.year) {
        Globals.showError('Debe seleccionar al menos un tipo de pago (mensual o anual)');
        return;
      }

      if (this.state.form.month && !this.state.form.price_month) {
        Globals.showError('Debe ingresar el precio mensual');
        return;
      }

      if (this.state.form.year && !this.state.form.price_year) {
        Globals.showError('Debe ingresar el precio anual');
        return;
      }
    }

    if (this.props.item != null) {
      await MembershipService.admin.update({
        membership_id: this.props.item?.id,
        ...this.state.form,
        hasFile: true,
        image: (this.state.form.image as MembershipImage)?.value || '',
        services: JSON.stringify(serviceToAdd),
      });
      Globals.showSuccess('Se ha modificado la membresía correctamente');
      this.props.onClose();
    } else {
      if (!this.state.form.image) {
        Globals.showError('Para continuar, debe seleccionar una imagen');
        return;
      }

      await MembershipService.admin.create({
        ...this.state.form,
        hasFile: true,
        image: (this.state.form.image as MembershipImage)?.value || '',
        services: JSON.stringify(serviceToAdd),
      });
      Globals.showSuccess('Se ha creado la membresía correctamente');
      this.props.onClose();
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  setLevel = (level_id: number) => {
    this.setState({
      form: {
        ...this.state.form,
        level_id,
      },
    });
  };

  setColor = (color_id: number) => {
    this.setState({
      form: {
        ...this.state.form,
        color_id,
      },
    });
  };

  render() {
    const filterdServices = this.state.services.filter(
      (i: any) => i.active && !SERVICE_NOT_IN_LIST.includes(i.id),
    );

    return (
      <div id='modal-create-membership'>
        <form onSubmit={this.submit}>
          <div className='container-inputs'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='image-selector'>
                  <PaperClip
                    formats={['png', 'jpg', 'jpeg']}
                    value={this.state.form.image}
                    width={1080}
                    height={1080}
                    onChange={(e: any) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          image: e.target,
                        },
                      });
                    }}
                  >
                    <div className='container-image'>
                      <img
                        src={
                          (this.state.form.image as MembershipImage)?.dataURL ||
                          (this.props.item?.image &&
                            Constants.BASE_STORAGE + this.props.item?.image) ||
                          AddImage
                        }
                        className={!this.state.form.image && !this.props.item?.image ? 'empty' : ''}
                      />
                    </div>
                  </PaperClip>
                  <div className='container-text'>
                    <p className='bold'>Subir imagen</p>
                    <p>Imagen PNG o JPG máximo 1080px por 1080px</p>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <Input
                  color='white'
                  value={this.state.form.name}
                  name='name'
                  label='Nombre'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-12'>
                <div
                  className='level-container price-container'
                  onClick={() =>
                    this.setState((prev: any) => ({
                      ...prev,
                      form: {
                        ...this.state.form,
                        specialized: !this.state.form.specialized,
                        level_id: Constants.LEVELS.CLIENT,
                        signs: null,
                      },
                      services: prev.services.map((i: any) => {
                        i.active = false;
                        i.marketplace = false;
                        return i;
                      }),
                    }))
                  }
                >
                  <div
                    className={`check-level ${this.state.form.specialized ? 'active' : ''}`}
                  ></div>
                  <p>Suscripción especializada o corporativa</p>
                </div>
              </div>
              {this.state.form.specialized == true && (
                <div className='col-md-12'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Area'
                    name='area_id'
                    onChange={(e: any) => this.change(e)}
                    value={this.state.form.area_id}
                    options={this.state.areas.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
              )}
            </div>
          </div>
          <div className='container-leaf'>
            <label>Seleccionar usuario</label>
            <div className='row'>
              <div className='col-md-6'>
                <div
                  className='level-container'
                  onClick={() => this.setLevel(Constants.LEVELS.CLIENT)}
                >
                  <div
                    className={`check-level ${parseInt(this.state.form.level_id) == Constants.LEVELS.CLIENT ? 'active' : ''}`}
                  ></div>
                  <p>Cliente</p>
                </div>
              </div>
              {this.state.form.specialized === false && (
                <div className='col-md-6'>
                  <div
                    className='level-container'
                    onClick={() => this.setLevel(Constants.LEVELS.LAWYER)}
                  >
                    <div
                      className={`check-level ${parseInt(this.state.form.level_id) == Constants.LEVELS.LAWYER ? 'active' : ''}`}
                    ></div>
                    <p>Abogado</p>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <label>Costo</label>
            <div className='row'>
              <div className='col-md-6'>
                <div
                  className='level-container price-container'
                  onClick={() =>
                    this.setState({
                      form: {
                        ...this.state.form,
                        is_free: !this.state.form.is_free,
                        month: Constants.PRICE_STATUS.NO,
                        year: Constants.PRICE_STATUS.NO,
                        price_month: '',
                        price_year: '',
                      },
                    })
                  }
                >
                  <div className={`check-level ${this.state.form.is_free ? 'active' : ''}`}></div>
                  <p>¿Es gratuita?</p>
                </div>
              </div>
              <div className='col-md-6'></div>
              <div className='col-md-6'>
                <div
                  className={`level-container price-container ${this.state.form.is_free ? 'disabled' : ''}`}
                  onClick={() =>
                    !this.state.form.is_free &&
                    this.setState({
                      form: {
                        ...this.state.form,
                        month: this.state.form.month
                          ? Constants.PRICE_STATUS.NO
                          : Constants.PRICE_STATUS.YES,
                      },
                    })
                  }
                >
                  <div className={`check-level ${this.state.form.month ? 'active' : ''}`}></div>
                  <p>Mensual</p>
                </div>
              </div>
              <div className='col-md-6'>
                <div
                  className={`level-container price-container ${this.state.form.is_free ? 'disabled' : ''}`}
                  onClick={() =>
                    !this.state.form.is_free &&
                    this.setState({
                      form: {
                        ...this.state.form,
                        year: this.state.form.year
                          ? Constants.PRICE_STATUS.NO
                          : Constants.PRICE_STATUS.YES,
                      },
                    })
                  }
                >
                  <div className={`check-level ${this.state.form.year ? 'active' : ''}`}></div>
                  <p>Anual</p>
                </div>
              </div>
              <div className='col-md-6'>
                {!this.state.form.is_free && !!this.state.form.month && (
                  <Input
                    type='decimal'
                    color='white'
                    value={this.state.form.price_month}
                    name='price_month'
                    placeholder='0.00'
                    className='price-input'
                    onChange={this.change}
                  />
                )}
              </div>
              <div className='col-md-6'>
                {!this.state.form.is_free && !!this.state.form.year && (
                  <Input
                    type='decimal'
                    color='white'
                    value={this.state.form.price_year}
                    name='price_year'
                    placeholder='0.00'
                    className='price-input'
                    onChange={this.change}
                  />
                )}
              </div>
            </div>
            <hr />
            <label>Selecciona un color</label>
            <div className='row'>
              {this.state.colors.map((item: any) => {
                return (
                  <div className='col-md-6'>
                    <div
                      className='level-container color-container'
                      onClick={() => this.setColor(item.id)}
                    >
                      <div
                        className={`check-level ${parseInt(this.state.form.color_id) == item.id ? 'active' : ''}`}
                        style={{
                          backgroundColor:
                            parseInt(this.state.form.color_id) == item.id
                              ? item.color
                              : 'transparent',
                        }}
                      ></div>
                      <p>{item.name}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className='container-inputs'>
            <Select
              color='white'
              placeholder='Seleccionar'
              label='Servicios'
              name='service_id'
              onChange={(e: any) => {
                const service_id = e.target.value;
                let services = [...this.state.services];
                const index = services.findIndex((i: any) => i.id == service_id);
                services[index].active = true;
                this.setState({
                  services,
                });
              }}
              value={this.state.form.service_id}
              options={this.getServices(false).map((item: any) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              })}
            />
            <p className='note'>
              Superada la cantidad de usos, se aplicará el precio establecido en los servicios
            </p>
            <p className='note font-weight-bold'>Recuerde que la cantidad de usos es por mes</p>
            <Table
              showAlwaysHeader={true}
              rightAlign={[1]}
              noItemsMessage='No ha añadido servicios'
              data={filterdServices}
              header={['Servicios', 'Cant. de uso']}
            >
              {filterdServices.map((item: MembershipServiceItem) => {
                return (
                  <tr>
                    <td>
                      <p className='service-name'>{item.name}</p>
                    </td>
                    <td className='text-right'>
                      <div className='container-uses'>
                        <div
                          className='level-container'
                          onClick={() => {
                            let services = [...this.state.services];
                            const index = services.findIndex((i) => i.id == item.id);
                            services[index].unlimited = !services[index].unlimited;
                            services[index].uses = 0;
                            this.setState({
                              services,
                            });
                          }}
                        >
                          <div className={`check-level ${item.unlimited ? 'active' : ''}`}></div>
                          <p>Ilimitado</p>
                        </div>
                        {!item.unlimited && (
                          <Input
                            color='white'
                            value={item.uses}
                            name='uses'
                            placeholder='0'
                            className='input-uses'
                            onChange={(e: any) => {
                              let services = [...this.state.services];
                              const index = services.findIndex((i) => i.id == item.id);
                              services[index].uses = e.target.value;
                              this.setState({
                                services,
                              });
                            }}
                          />
                        )}
                        <Tooltip title='Eliminar'>
                          <a
                            className='link-icon'
                            href='#'
                            onClick={(e: any) => {
                              e.preventDefault();
                              let services = [...this.state.services];
                              const index = services.findIndex((i) => i.id == item.id);
                              services[index].active = false;
                              this.setState({
                                services,
                              });
                            }}
                          >
                            <img src={TrashIcon} />
                          </a>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </Table>
            <hr />
            {!this.state.form.specialized && (
              <>
                <p className='label'>Habilitación de servicios</p>
                {this.state.services
                  .filter((i) => i.without_quantity)
                  .map((item: MembershipServiceItem) => {
                    if (this.state.form.specialized) return;
                    return (
                      <div
                        className='container-check'
                        onClick={() => {
                          let services = [...this.state.services];
                          const index = services.findIndex((i) => i.id == item.id);
                          services[index].marketplace = !services[index].marketplace;
                          this.setState({
                            services,
                          });
                        }}
                      >
                        <div className={`check ${item.marketplace ? 'active' : ''}`}>
                          {item.marketplace && <img src={CheckWhiteIcon} />}
                        </div>
                        <p>{item.name}</p>
                      </div>
                    );
                  })}
              </>
            )}
            {!this.state.form.specialized && (
              <>
                <hr />
                <p className='label'>Habilitación de firmar Electrónicas</p>
                <div className='row'>
                  <div
                    className='level-container price-container col-6'
                    onClick={() => {
                      let services = [...this.state.services];
                      const index = services.findIndex((i) => i.id == Constants.SERVICES.SIGN);
                      services[index].unlimited = true;
                      services[index].active = true;
                      this.setState({
                        services,
                        form: {
                          ...this.state.form,
                          signs: true,
                        },
                      });
                    }}
                  >
                    <div className={`check-level ${this.state.form.signs ? 'active' : ''}`}></div>
                    <p>Si</p>
                  </div>

                  <div
                    className='level-container price-container col-6'
                    onClick={() => {
                      let services = [...this.state.services];
                      const index = services.findIndex((i) => i.id == Constants.SERVICES.SIGN);
                      services[index].unlimited = false;
                      services[index].active = false;
                      this.setState({
                        services,
                        form: {
                          ...this.state.form,
                          signs: false,
                        },
                      });
                    }}
                  >
                    <div
                      className={`check-level ${this.state.form.signs === false ? 'active' : ''}`}
                    ></div>
                    <p>No</p>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className='text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreateMembership;
